import { useState } from "react";
import useAPI from "../../../../hooks/useAPI";

export const MAPEAMENTO_FILTERS = {
  USER: "user",
  MBA: "mba",
  PAID: "paid",
  PRO: "pro",
  TRAIL: "trail",
};

const buildMapeamentoCompetenciasUrl = ({
  baseUrl,
  page,
  rowsPerPage,
  filters,
}) => {
  const query = {
    page: page + 1,
    limit: rowsPerPage,
    ...(filters?.[MAPEAMENTO_FILTERS.USER] && {
      search: filters[MAPEAMENTO_FILTERS.USER],
    }),
    ...(filters?.[MAPEAMENTO_FILTERS.MBA] && {
      isMba: filters[MAPEAMENTO_FILTERS.MBA],
    }),
    ...(filters?.[MAPEAMENTO_FILTERS.PAID] && {
      isPaying: filters[MAPEAMENTO_FILTERS.PAID],
    }),
    ...(filters?.[MAPEAMENTO_FILTERS.PRO] && {
      isPro: filters[MAPEAMENTO_FILTERS.PRO],
    }),
    ...(filters?.[MAPEAMENTO_FILTERS.TRAIL] && {
      isTrail: filters[MAPEAMENTO_FILTERS.TRAIL],
    }),
  };

  const queryParams = new URLSearchParams(query);

  return `${baseUrl}?${queryParams.toString()}`;
};

export function useMapeamentoCompetencias() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [filters, setFilters] = useState({});

  const { data, isLoading, refreshData } = useAPI(
    buildMapeamentoCompetenciasUrl({
      baseUrl: "/general/pep/questions-with-answer",
      page,
      rowsPerPage,
      filters,
    })
  );

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const changeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    changePage(0);
  };

  const changeFilters = (newFilters) => {
    setFilters(newFilters);
    changePage(0);
  };

  const resetFilters = () => {
    changeFilters({});
  };

  return {
    data,
    isLoading,
    page,
    rowsPerPage,
    filters,
    changePage,
    changeRowsPerPage,
    changeFilters,
    resetFilters,
    refreshData,
  };
}
